import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class AboutHome extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            content:this.props.content, 
        }
        

    }

    componentDidMount()
    {  
         
        if(this.props.content && this.state.loading === 1)
        {
             this.setState({loading:0}); 

              
        }
        
        
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
          console.log(this.state.content);
    return (

        <div class="about-area default-padding ">
        <div class="container">
            <div class="row">
                <div class="col-md-6 info-content">
                 
                    <h1>{this.state.content[0]['title']}<br/><strong className='head1'>{this.state.content[0]['subtitle']}</strong> </h1>
                    <div dangerouslySetInnerHTML={{ __html: this.state.content[0].description }} />     
                    
                </div>
                
                <div class="col-md-6 right-content services">
                    <div class="row">
                        <div class="content-box">
                            <div class="center">
                                
                            <div class="col-md-6 col-sm-6 equal-height">
                                    <div class="item">
                                        <img src={this.state.content[16]['image']} alt={this.state.content[16]['title']} width="84"/>
                                        <h4>{this.state.content[16]['title']}</h4>
                                        
                                        <div dangerouslySetInnerHTML={{ __html: this.state.content[16].description }} /> 
                                         
                                    </div>
                                </div>
                                
                                <div class="col-md-6 col-sm-6 equal-height">
                                    <div class="item">
                                        <img src={this.state.content[17]['image']} alt={this.state.content[17]['title']} width="85"/>
                                        <h4 className='head4'>{this.state.content[17]['title']}</h4>
                                        
                                        <div dangerouslySetInnerHTML={{ __html: this.state.content[17].description }} /> 
                                         
                                    </div>
                                </div>
                                
                                <div class="col-md-6 col-sm-6 equal-height">
                                    <div class="item">
                                        <img src={this.state.content[19]['image']} alt={this.state.content[19]['title']} width="85"/>
                                        <h4 className='head4'>{this.state.content[19]['title']}</h4>
                                         
                                        <div dangerouslySetInnerHTML={{ __html: this.state.content[19].description }} /> 
                                        
                                    </div>
                                </div>
                                
                                <div class="col-md-6 col-sm-6 equal-height">
                                    <div class="item">
                                    <img src={this.state.content[18]['image']} alt={this.state.content[18]['title']} width="85"/>
                                        <h4 className='head4'>{this.state.content[18]['title']}</h4>
                                         
                                        <div dangerouslySetInnerHTML={{ __html: this.state.content[18].description }} /> 
                                         
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

       
    );
}

}

export default AboutHome;